"use client";

import { Button } from "@yardzen/ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@yardzen/ui/components/dialog";
import { useEffect, useState } from "react";
import { InlineWidget } from "react-calendly";

export interface ClientUserData {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
}

export default function ClientCalendlyPopup({ url }: { url: string }) {
  const [rootElement, setRootElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setRootElement(document.getElementById("root"));
  }, []);

  // Don't render until we have the root element
  if (!rootElement) {
    return null;
  }

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          id="calendly-popup-button"
          className="w-15 h-15 fixed bottom-5 right-5 z-50 drop-shadow-md"
        >
          Schedule a Free Call
        </Button>
      </DialogTrigger>
      <DialogContent
        className="!p-0 md:!h-full md:!max-h-[700px] md:!max-w-7xl"
        dialogCloseClassName="!top-2 !right-2"
      >
        <InlineWidget url={url} styles={{ height: "700px" }} />
      </DialogContent>
    </Dialog>
  );
}
